var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasModule
    ? _c(
        "w-card",
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$ct("inboxreader-purchases")) + " "),
              _c(
                "span",
                { staticClass: "target-email" },
                [
                  _vm._v(" (" + _vm._s(_vm.targetEmail) + ") "),
                  _c(
                    "w-link",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("edit-inboxreader-to"),
                          expression: "$ct('edit-inboxreader-to')",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          _vm.mailboxAliasEditOpen = true
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "pen" } })],
                    1
                  ),
                ],
                1
              ),
              _c("w-spacer"),
              _c(
                "div",
                [
                  _c("w-switch", {
                    attrs: {
                      value: _vm.settings.PurchasesFromInboxreaderEnabled,
                      reverse: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setEnabled($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.settings.PurchasesFromInboxreaderAllowedFroms.length == 0
            ? _c("w-card-content", [
                _c("div", { staticClass: "empty" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$ct("inboxreader-no-whitelisted-mails")) +
                      " "
                  ),
                ]),
              ])
            : _c(
                "w-list",
                [
                  _c(
                    "w-list",
                    [
                      _c("w-list-item", [
                        _vm._v(_vm._s(_vm.$ct("inboxreader-whitelist"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._l(
                    _vm.settings.PurchasesFromInboxreaderAllowedFroms,
                    function (item, i) {
                      return _c(
                        "w-list-item",
                        { key: item },
                        [
                          _c("w-list-item-text", [_vm._v(_vm._s(item))]),
                          _c(
                            "w-list-item-action",
                            [
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$ct("common.remove-item"),
                                      expression: "$ct('common.remove-item')",
                                    },
                                  ],
                                  staticClass: "danger",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteItem(i)
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "trash" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }
                  ),
                ],
                2
              ),
          _c(
            "w-card-actions",
            [
              _c("w-input", {
                staticClass: "mr",
                style: { flexGrow: 1 },
                attrs: {
                  "has-error":
                    !_vm.inputValid && _vm.input != "" && !_vm.inputFocussed,
                  placeholder: _vm.$ct("email-address"),
                },
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.addItem()
                  },
                  focus: function ($event) {
                    _vm.inputFocussed = true
                  },
                  blur: function ($event) {
                    _vm.inputFocussed = false
                  },
                },
                model: {
                  value: _vm.input,
                  callback: function ($$v) {
                    _vm.input = $$v
                  },
                  expression: "input",
                },
              }),
              _c(
                "w-button",
                {
                  attrs: { round: "", disabled: !_vm.inputValid },
                  on: {
                    click: function ($event) {
                      return _vm.addItem()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
            ],
            1
          ),
          _vm.mailboxAliasEditOpen
            ? _c("app-purchase-inbox-reader-settings-edit-mailbox-alias", {
                on: {
                  close: function ($event) {
                    return _vm.onAliasEditClosed()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _c("app-missing-module-modal", {
        attrs: {
          "module-id": _vm.moduleId,
          "shown-title": _vm.$ct("inboxreader-purchases"),
          "disable-max-width": "",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }